<template>
    <div style="width:100%;heigh:100%;" class="dictionary file-msg">
        <el-row :gutter="20">
            <el-col :span="3" style="padding-right:0px;">
                <el-card class="left-card">
                    <div class="left-title">
                        功能列表
                    </div>
                    <div class="middle-title">
                        功能名称
                        
                    </div>
                    <div>
                        <el-tabs v-model="activeName" @tab-click="handleClick" tab-position="left">
                            <el-tab-pane v-for="(item,index) in FileTypeOption" :key="index" :label="item.name" :name="item.key">
                                <span slot="label">
                                    {{ item.name }}
                                    <el-tooltip class="item" effect="dark" placement="right">
                                        <div slot="content">
                                            物料属性说明:<br/>
                                            字典信息将在以下模块实现物料信息的扩展：<br/>
                                            1、生产任务模块<br/>
                                            2、质检任务模块<br/>
                                            3、报表模块<br/>
                                            4、自定义流转卡模块<br/>
                                            5、库存管理模块<br/>
                                            6、采购管理模块<br/>
                                            7、派工单模块<br/>
                                            8、返工任务模块<br/>
                                        </div>
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </span>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="21" style="padding-left:0px;">
                <el-card class="table-card">
                    <div class="table_common_operbar">
                        <el-row style="margin-bottom: 14px;">
                            <div class="content-title">字典列表</div>
                        </el-row>
                        <el-row style="margin-bottom: 10px;">
                            <el-button type="primary" size="small" v-if="permission.btn_property_extend_create" @click="addBtn">新增</el-button>
                            <el-button type="primary" size="small" v-if="!sortEnable" @click="sortClick">点击排序</el-button>
                            <el-button type="primary" size="small" v-else @click="saveSortDatas">排序保存</el-button>
                        </el-row>
                    </div>
                    <el-table row-key="id" :row-class-name="sortEnable?'':'not-sort'" :maxHeight="700" :data="tableData" stripe style="width: 100%" class="deviceTable">
                        <el-table-column prop="propertyName" label="字典名称" min-width="110" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>
                                    <img v-if="sortEnable" src="/static/img/sort.png" alt="">
                                    <span>{{ scope.row.propertyName }}</span>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="inputTypeName" label="输入类型" min-width="80" show-overflow-tooltip></el-table-column>
                        <el-table-column label="长度限制" min-width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ scope.row.inputType==0?300:'-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="字典类型" min-width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ scope.row.inputType==0?'字符型':'-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" fixed="right" width="150">
                            <template slot-scope="scope">
                                <el-button @click="viewFile(scope.row)" type="text" size="small">查看</el-button>
                                <el-button @click="editFile(scope.row)" type="text" size="small" v-if="permission.btn_property_extend_update">编辑</el-button>
                                <el-button class="btn-del" @click="deleteFile(scope.row)" v-if="permission.btn_property_extend_delete" type="text" size="small">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog :title="title" :visible.sync="addDialogVisible" width="40%" center :before-close="cancalDialog">
            <el-form :model="addForm" :rules="rules" ref="addform" label-width="80px" style="width:100%;" class="add_form">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="字典名称" prop="propertyName">
                            <el-input size="small" :disabled="addForm.id!=''" v-model="addForm.propertyName" maxlength="6" placeholder="字典名称" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="输入类型" prop="inputType">
                            <el-select size="small" v-model="addForm.inputType" style="width:100%;">
                                <el-option :value="0" label="输入性"></el-option>
                                <el-option :value="1" label="选择型"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="addForm.inputType==0">
                        <el-form-item label="长度限制" prop="limitationLength">
                            <el-input size="small" disabled v-model="addForm.limitationLength" maxlength="50" placeholder="长度限制" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="addForm.inputType==0">
                        <el-form-item label="字典类型" prop="propertyType">
                            <el-input size="small" disabled v-model="addForm.propertyType" maxlength="50" placeholder="字典类型" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="addForm.inputType==1">
                        <el-form-item label="选择项目" prop="propertyType">
                            <el-table :data="addForm.projectList" stripe style="width: 100%" class="deviceTable">
                                <el-table-column type="index" label="序号" width="100" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="name" label="名称" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.name" maxlength="300" clearable placeholder="请输入"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" fixed="right">
                                    <template slot="header">
                                        <div style="display:flex;align-items:center;">
                                            <div class="import_upload">
                                                <a class="import_upload" href="/api/property-extend/template/download">
                                                    <el-button size='mini'>模板下载<i class="el-icon-download el-icon--right"></i></el-button>
                                                </a>
                                            </div>
                                            <span class="file-box el-button--mini">
                                                导入<input class="upload-file" id="fileupload" accept=".xls,.xlsx" type="file" @change="fn" />
                                            </span>
                                            <i style="cursor:pointer;" class="el-icon-circle-plus-outline" @click="addProject"></i>
                                        </div>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-button class="btn-del" @click="deleteProject(scope.$index)" type="text" size="small">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="el-dialog__footer" style="text-align: center;" center>
                <el-button type="primary" @click="saveDialog()">确定</el-button>
                <el-button @click="cancalDialog()" >取 消</el-button>
            </div>
        </el-dialog>  
        <el-dialog title="详情" :visible.sync="viewDialogVisible" width="40%" center>
            <el-row :gutter="20" style="margin-bottom:10px;">
                <el-col :span="12">
                    <span class="title">字典名称：</span>
                    <span>{{ viewForm.propertyName }}</span>
                </el-col>
                <el-col :span="12">
                    <span class="title">输入类型：</span>
                    <span>{{ viewForm.inputTypeName }}</span>
                </el-col>
                <el-col :span="12" v-if="viewForm.inputType==0">
                    <span class="title">长度限制：</span>
                    <span>{{ viewForm.limitationLength }}</span>
                </el-col>
                <el-col :span="12" v-if="viewForm.inputType==0">
                    <span class="title">字典类型：</span>
                    <span>{{ viewForm.propertyType }}</span>
                </el-col>
            </el-row>
            <el-row :gutter="20">    
                <el-col :span="24" v-if="viewForm.inputType==1">
                    <el-table :data="viewForm.projectList" stripe style="width: 100%" class="deviceTable">
                        <el-table-column type="index" label="序号" width="150" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="name" label="名称" show-overflow-tooltip></el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <div slot="footer" class="el-dialog__footer" style="text-align: center;" center>
                <el-button type="primary" @click="saveViewDialog()">确定</el-button>
            </div>
        </el-dialog>   
    </div>
</template>
<script>
import * as XLSX from 'xlsx';
import Sortable from 'sortablejs'
export default{
    data(){
        return{
            sortEnable:false,
            activeName:null,
            FileTypeOption:[
                {bizCode:"FileType",key:'0',name:"物料属性",remark:null}
            ],
            tableData:[],
            tableDataDrag:[],//排序后的数组
            addDialogVisible:false,
            addForm:{
                id:'',
                propertyName:'',
                inputType:null,
                limitationLength:300,
                propertyType:'字符型',
                projectList:[]
            },
            rules:{
                propertyName:[
                    { required: true, message: '请输入字典名称', trigger: 'blur' }
                ],
                inputType:[
                    { required: true, message: '请选择输入类型', trigger: 'blur' }
                ]
            },
            W: false,
            title: '新增',
            viewDialogVisible: false,
            viewForm:{
                id:'',
                propertyName:'',
                inputType:null,
                inputTypeName:'',
                limitationLength:300,
                propertyType:'字符型',
                projectList:[]
            },
            permission:JSON.parse(localStorage.getItem("permission"))
        }
    },
    mounted(){
        this.search();
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? this.W = true : this.W = false
        }
        
    },
    methods:{
        fn(e){
            let fileObj = e.target.files[0]
            // FileReader 对象就是专门操作二进制数据，主要用于将文件内容读入内存
            const fileReader = new FileReader()
            // .readAsArrayBuffer 读取制定的Bolb 或 File内容
            fileReader.readAsArrayBuffer(fileObj)
            fileReader.onload = (event)=>{
                const fileData = event.target.result
                // 从电子表格字节中提取数据
                const workbook = XLSX.read(fileData,{
                type:'binary'
                })
                // 按选项卡顺序列出工作表名称
                const wsname = workbook.SheetNames[0]
                // 从工作表创建JS值数组
                const sheetJson = XLSX.utils.sheet_to_json(workbook.Sheets[wsname])
                sheetJson.forEach((val,index)=>{
                    if(index!=0){//数组第一列为表头
                        let obj = {}
                        obj.name = Object.values(val)[0];
                        if(obj.name!=''){
                            this.addForm.projectList.push(obj)
                        }
                    }
                })
                e.target.value = '';
            }
        },
        sortClick(){
            this.sortEnable = true;
        },
        rowDrop(){//行-拖拽
            const tbody = document.querySelector('.dictionary .el-table__body-wrapper tbody')
            const _this = this
            Sortable.create(tbody, {
                filter: ".not-sort",  // 过滤.not-sort的元素
                onEnd({ newIndex, oldIndex }) {
                const currRow = _this.tableData.splice(oldIndex, 1)[0]
                _this.tableData.splice(newIndex, 0, currRow)
                //   拖动后获取newIdex
                let arr = Array.from(_this.tableData)
                _this.tableDataDrag = arr.map((item, index) => {
                    return {
                        id: item.id,
                        showIndex: index,
                    }
                })
                },
            })
        },
        saveSortDatas(){// 排序后，把拖动后的结果穿啊给后端
            if (this.tableDataDrag.length == 0) {
                //this.$message.warning("请先拖动字典数据，再点击");
                //return
                let arr = Array.from(this.tableData)
                this.tableDataDrag = arr.map((item, index) => {
                    return {
                        id: item.id,
                        showIndex: index,
                    }
                })
            }
            //console.log('tableDataDrag:',this.tableDataDrag)
            this.$RequestUtil.post({
                url: `/api/property-extend/sort?token=${localStorage.getItem("token")}`,
                type:'sync',
                params: this.tableDataDrag,
                success: (res) => {
                    if(res.code==0){
                        this.$message.success('排序成功');
                    }else{
                        this.$message.error(res.msg);
                    }
                    this.sortEnable = false;
                    this.search();
                }
            })
        },
        handleClick(){
            this.search();
        },
        search(){
            this.$RequestUtil.get({
                url: '/api/property-extend/list',
                type:'sync',
                params: {
                    type: Number(this.activeName)
                },
                success: (res) => {
                    if(res.code==0){
                        this.tableData = res.data;
                        this.$nextTick(() => {
                            this.rowDrop()
                        })
                    }
                }
            })
        },
        addBtn(){
            this.title = '新增';
            this.addDialogVisible = true;
        },
        viewFile(row){
            this.viewForm.id = row.id;
            this.viewForm.propertyName = row.propertyName;
            this.viewForm.inputType = row.inputType;
            this.viewForm.inputTypeName = row.inputTypeName;
            this.viewForm.limitationLength = '300';
            this.viewForm.propertyType = '字符型';
            this.viewForm.projectList = row.values.map((val)=>{
                let obj = {};
                obj.name = val;
                return obj
            })
            this.viewDialogVisible = true;
        },
        editFile(row){
            this.title = '编辑';
            this.addForm.id = row.id;
            this.addForm.propertyName = row.propertyName;
            this.addForm.inputType = row.inputType;
            this.addForm.limitationLength = '300';
            this.addForm.propertyType = '字符型';
            this.addForm.projectList = row.values.map((val)=>{
                let obj = {};
                obj.name = val;
                return obj
            })
            this.addDialogVisible = true;

        },
        deleteFile(row){
            this.$confirm(`是否确认删除?`, '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.get({
                    url: '/api/property-extend/delete',
                    type:'sync',
                    params: {
                        id:row.id
                    },
                    success: (res) => {
                        if(res.code==0){
                            this.$message.success('删除成功');
                            this.search();
                        }else{
                            this.$message.error(res.msg);
                        }
                    }
                })
            })
        },
        saveDialog(){
            let errmsg = false;
            if(this.addForm.projectList.length>0){
                this.addForm.projectList.forEach((val)=>{
                    if(val.name==''){
                        errmsg = true;
                    }
                })
                //判断是否有相同的name
                const newListLength=new Set(this.addForm.projectList.map(item=>item.name)).size;
                const listLength=this.addForm.projectList.length;
                if(listLength>newListLength){
                    this.$message.warning('项目名称不能重复！')
                    return
                }
            }
            if(errmsg){
                this.$message.warning('项目名称不能为空！')
                return
            }
            this.$refs["addform"].validate(valid => {
                if (valid) {
                    if(!this.addForm.id){//新增
                        this.$RequestUtil.post({
                            url: `/api/property-extend/create`,
                            type:'sync',
                            params: {
                                values:this.addForm.projectList.map((val)=>{ return val.name }),
                                propertyName:this.addForm.propertyName,
                                inputType:this.addForm.inputType,
                                type:Number(this.activeName)
                            },
                            success: (res) => {
                                if(res.code==0){
                                    this.$message.success('新增成功');
                                    this.cancalDialog();
                                    this.search();
                                }else{
                                    this.$message.error(res.message);
                                }
                            }
                        })
                    }else{//编辑
                        this.$RequestUtil.post({
                            url: `/api/property-extend/update`,
                            type:'sync',
                            params: {
                                id:this.addForm.id,
                                values:this.addForm.projectList.map((val)=>{ return val.name }),
                                propertyName:this.addForm.propertyName,
                                inputType:this.addForm.inputType,
                                type:Number(this.activeName)
                            },
                            success: (res) => {
                                if(res.code==0){
                                    this.$message.success('编辑成功');
                                    this.cancalDialog();
                                    this.search();
                                }else{
                                    this.$message.error(res.message);
                                }
                            }
                        })
                    }
                }
            })
        },
        cancalDialog(){
            this.$refs.addform.resetFields();
            this.addForm.id = '';
            this.addForm.propertyName = '';
            this.addForm.inputType = null;
            this.addForm.limitationLength = '300';
            this.addForm.propertyType = '字符型';
            this.addForm.projectList = [];
            this.addDialogVisible = false;
        },
        addProject(){
            this.addForm.projectList.push({name:''});
        },
        deleteProject(index){
            this.addForm.projectList.splice(index,1);
        },
        saveViewDialog(){
            this.viewDialogVisible = false;
        },
        saveSortData(){

        }
    }
}
</script>
<style>
.left-card .el-card__body{
    padding-left: 0px;
    padding-right: 0px;
}
.left-card .left-title{
    height: 35px;
    padding-left: 20px;
    font-weight: bold;
}
.left-card .middle-title{
    height: 35px;
    line-height: 35px;
    text-align: center;
    background: #F5F7FA;
}
.content-title{
    font-weight: bold;
}
.file-msg .import_upload {
    display: inline;
}
.file-box {
    position: relative;
    padding: 0;
    margin: 0 auto;
    display: inline-block;
    border: none;
    border-radius: 4px;
    background-color: #409eff;
    height: 30px;
    width: 60px;
    text-align: center;
    line-height: 30px;
    color: #FFFFFF;
}
.upload-file {
    font-size: 20px;
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
    filter: alpha(opacity=0);
    width: 100%;
}

</style>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/masterdata/Dictionary.vue